import { render, staticRenderFns } from "./TreatmentFormModal.vue?vue&type=template&id=5bb74b46&scoped=true"
import script from "./TreatmentFormModal.vue?vue&type=script&lang=js"
export * from "./TreatmentFormModal.vue?vue&type=script&lang=js"
import style0 from "./TreatmentFormModal.vue?vue&type=style&index=0&id=5bb74b46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb74b46",
  null
  
)

export default component.exports